import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useModal } from '@/providers/modal';
import { APP_LINKS } from '@/helpers/links';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';
import { DATA } from './data';

const id = MODAL_IDS.report_reference_modal;

export const ReportReferenceModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

const Modal = ({ accountType }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation('modal');
  const location = useLocation();

  const data = useMemo(() => {
    switch (location.pathname) {
      case APP_LINKS.cashMovements:
        return {
          list: DATA(t).cash_movements[accountType],
        };
      case APP_LINKS.portfolioMovements:
        return {
          list: DATA(t).portfolio_movements[accountType],
        };
      default:
        return {
          list: DATA(t).cash_movements.personal,
        };
    }
  }, [location.pathname, accountType]);

  const content = (
    <div className={s.modal}>
      <h1 className="f-hero-h5">{t('report_reference_modal.title')}</h1>
      <div className={s.content}>
        {data.list.map(item => (
          <div key={item.title} className={s.item}>
            <div className="f-small-accent">{item.title}</div>
            <div className="f-small-regular">{item.description}</div>
          </div>
        ))}
      </div>
      <div className={s.footer}>
        <button type="button" className={r.black_large} onClick={() => closeModal(id)}>
          {t('report_reference_modal.got_it')}
        </button>
      </div>
    </div>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
